import { useNotify } from '@globaleris/ui.library'
import i18n from 'i18next'
import { useCallback, useEffect, useState } from 'react'
import { fetchQuoteComments } from './quotes.service'

export const useGetQuoteComments = (quoteId: number, fetchTrigger: boolean = true) => {
  const [isFetching, setIsFetching] = useState<boolean>(false)
  const [fetchData, setFetchData] = useState<any[]>([])
  const { error } = useNotify()

  const getQuoteComments = useCallback(() => {
    setIsFetching(true)
    fetchQuoteComments(quoteId)
      .then(response => {
        if (response.success && response.data) {
          setFetchData(response.data)
        } else {
          error(i18n.t('quotes:notifications.GetQuoteCommentsError'))
        }
      })
      .finally(() => {
        setIsFetching(false)
      })
  }, [])

  useEffect(() => {
    fetchTrigger && getQuoteComments()
  }, [fetchTrigger])

  return { isFetching, fetchData, getQuoteComments }
}
